import type { OrganizationsTranslations } from "../interfaces/organizations";

export const organizationsTranslations: OrganizationsTranslations = {
  page_title: "Organizations",
  page_subtitle: "Find an organization and open its panel to decide which features its members get",
  action_refresh: "Refresh the list",
  action_retry: "Retry",
  action_clear_filters: "Clear filters",
  error_load: "We couldn't load the organizations.",

  filter_search_label: "Search",
  filter_search_placeholder: "Name, email, ID or user…",
  filter_search_min_length: "Type at least {{count}} characters to search.",
  filter_status_label: "Status",
  filter_status_all: "All statuses",
  filter_payout_batches_label: "Batch payouts",
  filter_payout_batches_all: "All",
  filter_payout_batches_enabled: "Enabled",
  filter_payout_batches_disabled: "Not enabled",

  col_name: "Organization",
  col_country: "Country",
  col_status: "Status",
  col_created: "Created",
  col_payout_batches: "Batch payouts",
  value_none: "—",

  status_active: "Active",
  status_inactive: "Inactive",
  status_suspended: "Suspended",
  status_pending: "Pending",

  payout_batches_switch_aria: "Batch payouts for {{name}}",

  empty_title: "No organizations yet",
  empty_description: "Client organizations will show up here once they sign up.",
  empty_filtered_title: "No organization matches",
  empty_filtered_description: "Try another term or clear the filters.",

  disable_dialog_title: "Remove batch payouts from {{name}}?",
  disable_dialog_description:
    "Its members will stop seeing the module and won't be able to upload, review or approve batches. Batches already being paid finish normally, and the Coloca team still sees them.",
  disable_dialog_confirm: "Remove access",
  disable_dialog_cancel: "Cancel",

  toast_payout_batches_enabled: "Batch payouts enabled for {{name}}",
  toast_payout_batches_disabled: "Batch payouts disabled for {{name}}",
  col_breb_key: "Bre-B key",
  breb_key_switch_aria: "Bre-B key for {{name}}",
  toast_breb_key_enabled: "Bre-B key enabled for {{name}}",
  toast_breb_key_disabled: "Bre-B key disabled for {{name}}. A key it already has stays.",
  rollout_body_on: "On for every verified organization, whatever its own switch says.",
  rollout_body_off: "Each decides: only the organizations you enable one by one have it.",
  rollout_switch_aria: "Bre-B key for every organization",
  rollout_confirm_on_title: "Turn the Bre-B key on for every organization?",
  rollout_confirm_on_body: "Any verified organization will be able to create its key from the dashboard.",
  rollout_confirm_on_cta: "Turn on for all",
  rollout_confirm_off_body:
    "Only the organizations switched on one by one will be able to create a key. Existing keys keep working.",
  rollout_cancel: "Cancel",
  toast_rollout_on: "Bre-B key turned on for every organization",
  toast_rollout_failed: "We could not change the global switch. Try again.",
  rollout_mode_per_organization: "Each decides",
  rollout_mode_on_for_all: "All",
  rollout_mode_off_for_all: "None",
  rollout_body_off_for_all:
    "Off for everyone: no organization has it, not even those whose own switch is on. That switch is kept and counts again once you lift the block.",
  rollout_confirm_per_organization_title: "Let each organization decide on {{feature}}?",
  rollout_confirm_per_organization_cta: "Let each decide",
  rollout_confirm_off_for_all_title: "Turn {{feature}} off for every organization?",
  rollout_confirm_off_for_all_cta: "Turn off for all",
  rollout_confirm_off_for_all_keeps:
    "Each organization's own switch is left as it is: back on “Each decides”, every one is where it was.",
  rollout_confirm_unblock_body:
    "Only the organizations whose own switch is on get it back, as they were before the block.",
  payout_batches_rollout_confirm_block_body:
    "No organization's members will see the module, not even those enabled. Batches already being paid finish normally, and Coloca staff keep access.",
  rollout_confirm_block_body:
    "No organization can create a new key. Keys that already exist keep receiving payments.",
  crypto_rollout_confirm_block_body:
    "No organization can buy or sell USDT, nor load cards with pesos, which buys USDT. Operations in progress finish normally.",
  card_deposits_rollout_confirm_block_body:
    "No crypto card will show its deposit QR. Deposits to addresses already shared are still recorded.",
  card_cop_top_ups_rollout_confirm_block_body:
    "No organization can load its cards with pesos. Top-ups in progress finish normally.",
  breb_qr_payments_rollout_confirm_block_body:
    "No organization can pay Bre-B QRs. Payments already sent go on.",
  toast_rollout_per_organization: "{{feature}}: each organization decides now",
  toast_rollout_off_for_all: "{{feature}}: off for every organization",
  features_off_for_all: "Off for everyone: {{features}}",
  feature_blocked_note_on:
    "Off for everyone from the general settings. Its own switch is on and counts again once the block is lifted.",
  feature_blocked_note_off: "Off for everyone from the general settings.",
  toast_update_failed: "We couldn't update {{name}}. Try again.",
  col_crypto: "Crypto",
  crypto_switch_aria: "Crypto for {{name}}",
  toast_crypto_enabled: "Crypto enabled for {{name}}",
  toast_crypto_disabled: "Crypto disabled for {{name}}. Its operations in progress finish normally.",
  crypto_rollout_body_on: "On for every organization, whatever its own switch says.",
  crypto_rollout_body_off: "Each decides: only the organizations you enable one by one have it.",
  crypto_rollout_switch_aria: "Crypto for every organization",
  crypto_rollout_confirm_on_title: "Turn Crypto on for every organization?",
  crypto_rollout_confirm_on_body: "Any organization will be able to buy and sell USDT from the dashboard.",
  crypto_rollout_confirm_off_body:
    "Only the organizations switched on one by one will be able to buy and sell USDT. Operations in progress finish normally.",
  toast_crypto_rollout_on: "Crypto turned on for every organization",
  col_card_deposits: "Stablecoin QR",
  card_deposits_switch_aria: "Stablecoin deposit QR for {{name}}",
  toast_card_deposits_enabled: "Stablecoin deposit QR visible on {{name}}'s cards",
  toast_card_deposits_disabled:
    "Stablecoin deposit QR hidden for {{name}}. Deposits that still arrive are recorded.",
  card_deposits_rollout_body_on:
    "On: every crypto card shows its QR, whatever its organization's own switch says.",
  card_deposits_rollout_body_off:
    "Each decides: only the cards of the organizations you enable one by one show it.",
  card_deposits_rollout_switch_aria: "Stablecoin deposit QR for every organization",
  card_deposits_rollout_confirm_on_title: "Show the deposit QR on every crypto card?",
  card_deposits_rollout_confirm_on_body:
    "Every organization will see the deposit address of its crypto cards and can top them up by sending USDT or USDC on Polygon.",
  card_deposits_rollout_confirm_off_body:
    "Only the organizations enabled one by one will see the QR. Deposits that reach addresses already shared are still recorded.",
  toast_card_deposits_rollout_on: "Stablecoin deposit QR visible for every organization",
  col_card_cop_top_ups: "Pesos → card",
  card_cop_top_ups_switch_aria: "Load cards with pesos for {{name}}",
  toast_card_cop_top_ups_enabled: "{{name}} can now load its crypto cards with its peso balance",
  toast_card_cop_top_ups_disabled:
    "Loading cards with pesos turned off for {{name}}. Top-ups in progress finish normally.",
  card_cop_top_ups_rollout_body_on:
    "On: every organization can load its crypto cards with its peso balance, whatever its own switch says.",
  card_cop_top_ups_rollout_body_off:
    "Each decides: only the organizations you enable one by one have it. It is independent of the stablecoin QR.",
  card_cop_top_ups_rollout_switch_aria: "Load cards with pesos for every organization",
  card_cop_top_ups_rollout_confirm_on_title: "Enable loading cards with pesos for everyone?",
  card_cop_top_ups_rollout_confirm_on_body:
    "Every organization will see «Peso balance» when loading its crypto cards: we buy USDT with its pesos and send it to the card.",
  card_cop_top_ups_rollout_confirm_off_body:
    "Only the organizations enabled one by one will keep seeing it. Top-ups already placed finish normally.",
  toast_card_cop_top_ups_rollout_on: "Loading cards with pesos enabled for every organization",
  custom_key_action: "Assign custom key",
  custom_key_action_aria: "Assign a custom Bre-B key to {{name}}",
  custom_key_title: "Custom key for {{name}}",
  custom_key_description:
    "A key of your choosing instead of one built from the organization’s data. Only authorized people see this option.",
  custom_key_input_label: "Key",
  custom_key_input_placeholder: "yourcompany",
  custom_key_format_hint: "5 to 20 letters or numbers, with no spaces, accents or symbols.",
  custom_key_invalid: "Use 5 to 20 letters or numbers, with no spaces, accents or symbols.",
  custom_key_checking: "Checking…",
  custom_key_available: "Available",
  custom_key_taken_coloca: "Taken by a Coloca account",
  custom_key_taken_elsewhere: "Registered at another Bre-B institution",
  custom_key_unknown: "We could not check it",
  custom_key_check_again: "Check again",
  custom_key_preview_label: "How payers will see it",
  custom_key_rollout_note:
    "The organization does not need the Bre-B key enabled. Afterwards it uses the key and can delete it like any other.",
  custom_key_keys_title: "{{name}}'s keys",
  custom_key_assign_another: "Assign another custom key",
  custom_key_not_verified:
    "The organization’s verification is not approved, so a key cannot be assigned yet.",
  custom_key_rail_disabled: "Bre-B collections are off for this organization.",
  custom_key_load_error: "We could not read the organization’s key.",
  custom_key_retry: "Retry",
  custom_key_assign: "Assign key",
  custom_key_cancel: "Cancel",
  custom_key_two_factor_required: "Turn on two-step verification to assign keys.",
  custom_key_two_factor_description:
    "Enter the code from your authenticator app to assign {{key}} to {{name}}.",
  custom_key_assigned_toast: "You assigned the key {{key}} to {{name}}.",
  custom_key_assigned_pending_toast:
    "You assigned the key {{key}} to {{name}}. It goes live in a few seconds.",
  custom_key_transfer_action: "Move to another organization",
  custom_key_transfer_action_aria: "Move the key {{key}} to another organization",
  custom_key_transfer_title: "Move {{key}}",
  custom_key_transfer_description:
    "The key goes to another organization without being deleted from Bre-B, so nobody can take it on the way.",
  custom_key_transfer_picker_label: "Organization that receives it",
  custom_key_transfer_picker_required_hint: "Choose the organization that keeps the key.",
  custom_key_transfer_picker_org_hint: "Below you see what changes for each organization.",
  custom_key_transfer_same_org: "That organization already holds the key. Choose another one.",
  custom_key_transfer_loading: "Checking what changes…",
  custom_key_transfer_side_from: "From",
  custom_key_transfer_side_to: "To",
  custom_key_transfer_primary: "Primary key",
  custom_key_transfer_primary_shared: "Coloca's shared key",
  custom_key_transfer_primary_changes: "Changes",
  custom_key_transfer_primary_same: "No change",
  custom_key_transfer_primary_this: "Becomes this one",
  custom_key_transfer_arrives_as: "At {{name}} it stays as a {{source}} key.",
  custom_key_transfer_static_qr:
    "The any-amount QR goes with the key: whatever is paid through it reaches {{name}}.",
  custom_key_transfer_live_qrs:
    "{{name}} has {{count}} collection(s) with a QR still payable over this key. If they are paid, the money reaches {{name}}; they expire within 60 minutes.",
  custom_key_transfer_in_flight:
    "A payment that lands in the very minute of the move is held to be reconciled by hand.",
  custom_key_transfer_otc_title: "{{name}} has USDT operations in progress on this key",
  custom_key_transfer_otc_sales: "{{count}} sale(s) can still pay their pesos to this key.",
  custom_key_transfer_otc_purchases: "{{count}} purchase(s) would be refunded to this key if they fail.",
  custom_key_transfer_otc_wait: "You can move it once they finish.",
  custom_key_transfer_problem_title: "{{name}} can't receive the key yet",
  custom_key_transfer_problem_verification_required:
    "Its verification isn't approved yet. Once it is, you can move the key to it.",
  custom_key_transfer_problem_rail_disabled: "Bre-B collections are off for it, so it can't receive the key.",
  custom_key_transfer_problem_no_pricing:
    "It has no route or commission set up for Bre-B collections, so the key's amount limits can't be set.",
  custom_key_transfer_submit: "Move key",
  custom_key_transfer_two_factor_required: "Turn on two-step authentication to move keys.",
  custom_key_transfer_two_factor_description:
    "Enter the code from your authenticator app to move {{key}} to {{name}}.",
  custom_key_transferred_toast: "You moved the key {{key}} to {{name}}.",
  col_features: "Features",
  features_none: "None",
  features_only_global: "Only the general ones",
  features_for_all: "On for everyone: {{features}}",
  action_change: "Change",
  action_configure: "Configure",
  configure_aria: "Configure {{name}}",
  action_global_settings: "General settings",
  detail_id: "ID",
  copy_id_aria: "Copy the ID",
  id_copied: "ID copied",
  features_title: "Features",
  features_hint: "Changes are saved right away.",
  features_read_only: "Read only: you do not have permission to edit organizations.",
  feature_global_note: "On for everyone from the general settings.",
  feature_payout_batches_description:
    "Its members upload a file and pay many beneficiaries in one operation, approved with a verification code.",
  feature_breb_key_description:
    "It can create its own Bre-B key to receive transfers, plus its QR for any amount.",
  feature_crypto_description: "It can buy USDT with its peso wallet balance and sell USDT to receive pesos.",
  feature_card_deposits_description:
    "Its crypto cards show their deposit address (QR) so they can be topped up with USDT or USDC.",
  feature_card_cop_top_ups_description:
    "Its crypto cards can be loaded from the peso balance: we buy USDT and send it to the card.",
  global_settings_title: "General settings",
  global_settings_description:
    "Each feature can be left to each organization, on for everyone or off for everyone. While it is on or off for everyone, each organization's own switch does not count, but it is kept.",
  global_settings_load_error: "We could not read the general settings.",
  payout_batches_rollout_body_on: "On for every organization, whatever its own switch says.",
  payout_batches_rollout_body_off: "Each decides: only the organizations you enable one by one have it.",
  payout_batches_rollout_switch_aria: "Batch payouts for every organization",
  payout_batches_rollout_confirm_on_title: "Turn batch payouts on for every organization?",
  payout_batches_rollout_confirm_on_body:
    "The members of any organization will be able to upload, review and approve batches from the dashboard.",
  payout_batches_rollout_confirm_off_body:
    "Only the organizations enabled one by one will keep the module. Batches already being paid finish normally.",
  toast_payout_batches_rollout_on: "Batch payouts on for every organization",
  col_breb_qr_payments: "Pay with QR",
  feature_breb_qr_payments_description:
    "It can pay Bre-B QR codes of businesses and people with its COP wallet balance.",
  breb_qr_payments_switch_aria: "Pay with QR for {{name}}",
  toast_breb_qr_payments_enabled: "{{name}} can now pay with QR",
  toast_breb_qr_payments_disabled: "Pay with QR turned off for {{name}}. Payments already sent keep going.",
  col_breb_qr_unsupported: "Unsupported QRs",
  feature_breb_qr_unsupported_description:
    "It can pay QRs with a fixed convenience fee, which today complete but never reach the merchant. Turn it on only to test whether they work now.",
  breb_qr_unsupported_switch_aria: "Unsupported QRs for {{name}}",
  toast_breb_qr_unsupported_enabled: "{{name}} can now pay unsupported QRs",
  toast_breb_qr_unsupported_disabled:
    "Unsupported QRs turned off for {{name}}. They show as not supported again.",
  breb_qr_payments_rollout_body_on: "On: every organization can pay QRs, whatever its own switch says.",
  breb_qr_payments_rollout_body_off:
    "Each decides: only the organizations you enable one by one can pay QRs.",
  breb_qr_payments_rollout_switch_aria: "Pay with QR for every organization",
  breb_qr_payments_rollout_confirm_on_title: "Turn pay with QR on for every organization?",
  breb_qr_payments_rollout_confirm_on_body:
    "Every organization will be able to scan and pay Bre-B QR codes from its COP wallet.",
  breb_qr_payments_rollout_confirm_off_body:
    "Only the organizations enabled one by one will be able to pay QRs. Payments already sent keep going.",
  toast_breb_qr_payments_rollout_on: "Pay with QR on for every organization",

  matched_user: "User: {{name}} · {{email}}",
  matched_users_more: "+{{count}}",

  tab_overview: "Overview",
  tab_users: "Users",
  tab_features: "Features",
  overview_load_error: "We couldn't load this organization's overview.",
  overview_forbidden: "Your role lacks the read permissions to see organization overviews.",

  overview_status_title: "Standing",
  overview_verification_label: "Verification",
  overview_purpose_kyc: "KYC",
  overview_purpose_kyb: "KYB",
  identity_type_business: "Company",
  identity_type_individual: "Person",
  overview_verification_none: "No identity of its own yet: verification hasn't started.",
  overview_verification_verified_at: "Approved on {{date}}.",
  overview_verification_in_review: "We're reviewing it.",
  overview_verification_pending: "It hasn't finished sending its details yet.",
  overview_verification_expired: "Expired: it has to be verified again.",
  overview_cards_label: "Cards",
  overview_cards_provider_label: "Cards · {{provider}}",
  overview_cards_no_provider: "No card provider assigned.",
  overview_cards_own_none: "Not registered itself",
  overview_cards_paused: "Paused: {{reason}}",
  overview_cards_holders_label: "Cardholders",
  overview_cards_holders_none: "No cardholders registered yet.",
  overview_access_label: "Access",
  overview_access_active: "Active: {{count}}",
  overview_access_none: "No users: nobody can sign in to the dashboard.",
  overview_access_last_login: "Last sign-in {{when}}, {{name}}.",
  overview_access_never: "No user has signed in yet.",
  provider_crypto: "Coloca Crypto",
  provider_cards: "Coloca Cards",

  stage_not_registered: "Not registered",
  stage_in_progress: "In progress",
  stage_paused: "Paused",
  stage_in_review: "In review",
  stage_enabled: "Enabled",
  stage_rejected: "Rejected",
  holders_not_registered: "not registered",
  holders_in_progress: "in progress",
  holders_paused: "paused",
  holders_in_review: "in review",
  holders_enabled: "enabled",
  holders_rejected: "rejected",
  pause_reason_business_identity: "it is a company, and only people can be cardholders",
  pause_reason_missing_identity_fields: "the last name or date of birth is missing",
  pause_reason_missing_email: "a contact email is missing",
  pause_reason_missing_address: "the home address is missing",
  pause_reason_unmappable_state: "we don't recognise the state or province of the address",
  pause_reason_missing_client_data: "cardholder details are missing",
  pause_reason_documents_unavailable: "we couldn't fetch the documents from the verification",
  pause_reason_already_registered: "the person is already registered under another identity",
  pause_reason_other: "another reason; check the team alerts",

  overview_details_title: "Details",
  detail_phone: "Phone",
  detail_created_by: "by {{name}}",

  overview_activity_title: "Activity",
  activity_wallets: "Wallets",
  activity_wallets_none: "No wallets activated.",
  wallet_frozen: "frozen",
  wallet_closed: "closed",
  activity_last_payin: "Last collection",
  activity_last_payout: "Last payout",
  activity_last_value: "{{when}} · {{count}} in 30 days",
  activity_never: "Never",
  activity_cards: "Cards",
  activity_cards_value: "{{total}} · active {{active}} · frozen {{frozen}}",
  activity_holders: "Cardholders",
  activity_breb_keys: "Bre-B keys",
  activity_api_keys: "API keys",
  activity_api_keys_value: "Active: {{count}}",
  activity_api_keys_used: "Active: {{count}} · used {{when}}",
  activity_none: "None",

  member_status_active: "Active",
  member_status_pending_verification: "Unverified",
  member_status_inactive: "Deactivated",
  member_status_suspended: "Suspended",
  members_active: "Active",
  members_pending_verification: "Unverified",
  members_inactive: "Deactivated",
  members_suspended: "Suspended",
  users_empty_title: "No users",
  users_empty_description: "Nobody from this organization can sign in to the dashboard.",
  user_last_login: "Signed in {{when}}",
  user_never_logged_in: "Never signed in",
  user_two_factor: "2FA on",
  copy_email_aria: "Copy {{name}}'s email",
  email_copied: "Email copied",
  users_truncated: "Showing the first {{count}}.",
  col_card_wallet: "Card wallet",
  card_wallet_switch_aria: "Card wallet for {{name}}",
  toast_card_wallet_enabled: "{{name}} now has the card wallet: it can take balance back from its cards",
  toast_card_wallet_disabled:
    "Card wallet turned off for {{name}}. Its cards load from pesos or crypto, and their balance only moves between cards.",
  feature_card_wallet_description:
    "A dollar balance to load its cards instantly and take balance back from them. Without it, crypto cards load from pesos or crypto and their balance only moves between cards.",
  col_card_design: "Customize card",
  card_design_switch_aria: "Customize card for {{name}}",
  toast_card_design_enabled: "{{name}} can now customize its cards: its design shows in the secure card view",
  toast_card_design_disabled:
    "Customization turned off for {{name}}. Its cards go back to the Coloca design; its design stays saved.",
  feature_card_design_description:
    "Its own colors and logo, next to the Coloca mark, in the secure card view it shows through the API. The card in Apple Pay or Google Pay does not change.",
  col_payout_batches_self_approval: "Batch self-approval",
  payout_batches_self_approval_switch_aria: "Batch self-approval for {{name}}",
  toast_payout_batches_self_approval_enabled: "Batch self-approval turned on for {{name}}",
  toast_payout_batches_self_approval_disabled: "Batch self-approval turned off for {{name}}",
  feature_payout_batches_self_approval_description:
    "Whoever prepares a batch can approve it with their code even when someone else could. Off, only an organization's sole approver does. Its approvers can also change it from Settings.",
};
